import { createFileRoute } from "@tanstack/react-router";
import { ResidentDocumentsPage } from "@/components/app/portal/pages/resident-documents-page";

export const Route = createFileRoute("/family-portal/$residentId/documents")({
  head: () => ({ meta: [{ title: "Documents | People AI" }] }),
  component: FamilyDocuments,
});

function FamilyDocuments() {
  const { residentId } = Route.useParams();
  return <ResidentDocumentsPage kind="family" residentId={residentId} />;
}
